module.exports = __webpack_public_path__ + "static/media/dem_imp_ham.2b510b66.png";